import * as React from 'react';
import { useSelector } from 'react-redux';

import { useIsDesktop } from 'shared/utils/useIsDesktop';
import { useAppDispatch } from 'shared/hooks/useAppDispatch';
import { useSendCPDAnalytics } from 'shared/hooks/useSendCPDAnalytics';
import { ECPDEntrySource, ECPDModalType } from 'shared/types/redux/cpd';
import { changeModalType, setCpdDraftSource, setCpdPickLandingChannel } from 'shared/actions/cpd';
import { CPL_FORM_URL } from 'shared/constants/cpd';
import { getCurrentTab } from 'shared/selectors/tabs';
import { getCPDDraftSourceByCurrentTab, getCPDPikLandingChannelByCurrentTab } from 'shared/utils/cpd';

import { useGetCPDSettings } from './hooks';
import { CPDBanner } from './CPDBanner';

export const CPDBannerContainer: React.FC = () => {
  const { isBannerVisible, isCurrentGeoInCPD, CPDBannerData } = useGetCPDSettings();
  const isDesktop = useIsDesktop();
  const dispatch = useAppDispatch();
  const currentTab = useSelector(getCurrentTab);
  const { sendCPDBannerEvent } = useSendCPDAnalytics();

  React.useEffect(() => {
    if (isBannerVisible) {
      sendCPDBannerEvent({ action: 'Show_sopr' });
    }
  }, [isBannerVisible, sendCPDBannerEvent]);

  const submitRequest = React.useCallback(() => {
    sendCPDBannerEvent({ action: 'Click' });

    if (isCurrentGeoInCPD) {
      const pikLandingChannel = getCPDPikLandingChannelByCurrentTab(currentTab, ECPDEntrySource.Banner);
      const cpdDraftSource = getCPDDraftSourceByCurrentTab(currentTab, ECPDEntrySource.Banner);

      dispatch(changeModalType(ECPDModalType.Initial));
      dispatch(setCpdPickLandingChannel(pikLandingChannel));
      dispatch(setCpdDraftSource(cpdDraftSource));

      return;
    }

    window.location.href = CPL_FORM_URL;
  }, [isCurrentGeoInCPD, currentTab, sendCPDBannerEvent, dispatch]);

  if (!isBannerVisible || !CPDBannerData) {
    return null;
  }

  return <CPDBanner submitRequest={submitRequest} isDesktop={isDesktop} CPDBannerData={CPDBannerData} />;
};
